export default function reducer(state, action) {
    if (state.get('elementId') === action.elementId) {
        switch (action.type) {
        }
    }
    return state;
}
